import { BrowserRouter, Routes, Route } from "react-router-dom";
import SharedLayout from "./components/SharedLayout";
import Home from "./components/Home";
import About from "./components/About";
import Projects from "./components/Projects";
import Services from "./components/Services";
import News from "./components/News";
import NewsDetail from "./components/NewsDetail";
import NewsCategory from "./components/NewsCategory";
import NewsHeader from "./components/NewsHeader";
import Contact from "./components/Contact";
import Error from "./components/Error";
import * as ROUTES from "./constants/routes";
import "./sass/app.scss";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.HOME} element={<SharedLayout />}>
          <Route index element={<Home />} />
          <Route path={ROUTES.ABOUT} element={<About />} />
          <Route path={ROUTES.PROJECTS} element={<Projects />} />
          <Route path={ROUTES.SERVICES} element={<Services />} />

          <Route path={ROUTES.NEWS} element={<NewsHeader />}>
            <Route index element={<News />} />
            <Route
              path={ROUTES.NEWS_CATEGORY + "/:id"}
              element={<NewsCategory />}
            />
          </Route>

          <Route
            path={ROUTES.NEWS + "/" + ROUTES.NEWS_DETAIL + "/:id"}
            element={<NewsDetail />}
          />

          <Route path={ROUTES.CONTACT} element={<Contact />} />
          <Route path={ROUTES.ERROR} element={<Error />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
